<app-topbar></app-topbar>
<div class="content-container">
  <app-navbar></app-navbar>
  <div class="container-fluid">
    <br />
    <!-- Pestañas -->
    <ul class="nav nav-tabs">
      <li
        [ngClass]="{ active: pestaniaSeleccionada === 'relacionDependencia' }"
      >
        <a (click)="seleccionarPestania('relacionDependencia')"
          >Relación de Dependencia</a
        >
      </li>
      <li [ngClass]="{ active: pestaniaSeleccionada === 'otros' }">
        <a (click)="seleccionarPestania('otros')">Otros</a>
      </li>
    </ul>

    <div class="card mb-4">
      <div
        class="card-header d-flex justify-content-between align-items-center"
      >
        <span>Filtros</span>
        <button
          type="button"
          class="btn btn-link p-0"
          (click)="toggleFiltros()"
        >
          <i
            class="bi"
            [ngClass]="{
              'bi-chevron-up': filtrosVisible,
              'bi-chevron-down': !filtrosVisible
            }"
          ></i>
        </button>
      </div>
      <div class="card-body" [ngClass]="{ 'd-none': !filtrosVisible }">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 col-md-5 col-lg-4">
              <div class="mb-3">
                <label for="tipoSelect" class="form-label"
                  ><strong>Tipo</strong></label
                >
                <select
                  id="tipoSelect"
                  class="form-select"
                  [(ngModel)]="filtro.tipo"
                >
                  <option value="">Todos</option>
                  <option value="adherentes">Solo Adherentes</option>
                  <option value="titulares">Solo Titulares</option>
                </select>
              </div>
              <!-- Grupo Estado -->
              <div class="mb-3">
                <label for="estadoSelect" class="form-label"
                  ><strong>Estado</strong></label
                >
                <select
                  id="estadoSelect"
                  class="form-select"
                  [(ngModel)]="filtro.estado"
                >
                  <option value="">Todos</option>
                  <option value="activos">Activos</option>
                  <option value="inactivos">Inactivos</option>
                </select>
              </div>
            </div>
            <!-- Columna de selects -->
            <div class="col-12 col-md-7 col-lg-8">
              <!-- Primera fila de selects: Plan, Obra Social y Tipo Beneficiario -->
              <div class="row">
                <!-- Select Plan -->
                <div class="col-12 col-md-4 col-lg-4">
                  <div class="mb-3">
                    <label for="planSelect" class="form-label">Plan</label>
                    <select
                      id="planSelect"
                      class="form-select"
                      [(ngModel)]="filtro.plan"
                    >
                      <option value="">Todos</option>
                      <option *ngFor="let plan of planes" [value]="plan.id">
                        {{ plan.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- Select Obra Social -->
                <div class="col-12 col-md-4 col-lg-4">
                  <div class="mb-3">
                    <label for="obraSocialSelect" class="form-label"
                      >Obra Social</label
                    >
                    <select
                      id="obraSocialSelect"
                      class="form-select"
                      [(ngModel)]="filtro.obraSocial"
                    >
                      <option value="">Todos</option>
                      <option
                        *ngFor="let obra of obrasSociales"
                        [value]="obra.id"
                      >
                        {{ obra.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- Select Tipo Beneficiario -->
                <div class="col-12 col-md-4 col-lg-4">
                  <div class="mb-3">
                    <ng-container
                      *ngIf="mostrarCampoBeneficiario; else espacioVacio"
                    >
                      <label for="tipoBeneficiarioSelect" class="form-label"
                        >Tipo de Beneficiario</label
                      >
                      <select
                        id="tipoBeneficiarioSelect"
                        class="form-select"
                        [(ngModel)]="filtro.tipoBeneficiario"
                      >
                        <option value="">Todos</option>
                        <option
                          *ngFor="let tipo of tiposBeneficiario"
                          [value]="tipo.id"
                        >
                          {{ tipo.descripcion }}
                        </option>
                      </select>
                    </ng-container>
                    <ng-template #espacioVacio>
                      <div style="height: 58px"></div>
                    </ng-template>
                  </div>
                </div>
              </div>
              <!-- Segunda fila de selects: Provincia y Localidades -->
              <div class="row">
                <!-- Select Provincia -->
                <div class="col-12 col-md-6 col-lg-6">
                  <div class="mb-3">
                    <label for="provinciaSelect" class="form-label"
                      >Provincia</label
                    >
                    <select
                      id="provinciaSelect"
                      class="form-select"
                      [(ngModel)]="filtro.idProvincia"
                      (change)="onProvinciaChange()"
                    >
                      <option value="">Todas</option>
                      <option
                        *ngFor="let provincia of provincias"
                        [value]="provincia.id"
                      >
                        {{ provincia.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- Select Localidades -->
                <div class="col-12 col-md-6 col-lg-6">
                  <div class="mb-3">
                    <label for="localidadSelect" class="form-label"
                      >Localidades</label
                    >
                    <select
                      id="localidadSelect"
                      class="form-select"
                      [(ngModel)]="filtro.idLocalidad"
                      [disabled]="
                        !filtro.idProvincia || localidades.length === 0
                      "
                    >
                      <option value="null" disabled selected>
                        Seleccione una localidad
                      </option>
                      <option
                        *ngFor="let localidad of localidades"
                        [value]="localidad.id"
                      >
                        {{ localidad.descripcion }} ({{
                          localidad.codigoPostal
                        }})
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Tercera fila: Fechas y botón buscar -->
          <div class="row align-items-end">
            <!-- Fecha Desde -->
            <div class="col-12 col-md-4 col-lg-4">
              <div class="mb-3">
                <label for="fechaDesdeInput" class="form-label"
                  >Fecha Venta Desde</label
                >
                <div class="input-group">
                  <input
                    class="form-control"
                    placeholder="dd/mm/yyyy"
                    name="fechaDesde"
                    [(ngModel)]="filtro.fechaDesdeText"
                    ngbDatepicker
                    #fechaDesdePicker="ngbDatepicker"
                    (ngModelChange)="onFechaDesdeChange($event)"
                    [minDate]="{ year: 2000, month: 1, day: 1 }"
                    [maxDate]="{ year: 2030, month: 12, day: 31 }"
                  />
                  <button
                    class="btn btn-outline-secondary bi bi-calendar3"
                    (click)="fechaDesdePicker.toggle()"
                    type="button"
                  ></button>
                  <button
                    *ngIf="filtro.fechaDesdeText"
                    class="btn btn-outline-secondary"
                    type="button"
                    (click)="limpiarFecha('fechaDesde')"
                  >
                    <i class="bi bi-x"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Fecha Hasta -->
            <div class="col-12 col-md-4 col-lg-4">
              <div class="mb-3">
                <label for="fechaHastaInput" class="form-label"
                  >Fecha Venta Hasta</label
                >
                <div class="input-group">
                  <input
                    class="form-control"
                    placeholder="dd/mm/yyyy"
                    name="fechaHasta"
                    [(ngModel)]="filtro.fechaHastaText"
                    ngbDatepicker
                    #fechaHastaPicker="ngbDatepicker"
                    (ngModelChange)="onFechaHastaChange($event)"
                    [minDate]="{ year: 2000, month: 1, day: 1 }"
                    [maxDate]="{ year: 2030, month: 12, day: 31 }"
                  />
                  <button
                    class="btn btn-outline-secondary bi bi-calendar3"
                    (click)="fechaHastaPicker.toggle()"
                    type="button"
                  ></button>
                  <button
                    *ngIf="filtro.fechaHastaText"
                    class="btn btn-outline-secondary"
                    type="button"
                    (click)="limpiarFecha('fechaHasta')"
                  >
                    <i class="bi bi-x"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Botón Buscar (ahora está en la misma fila) -->
            <div
              class="col-12 col-md-4 col-lg-4 d-flex justify-content-end mb-3"
            >
              <button class="btn btn-primary" (click)="buscar()">Buscar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Card de Totalizadores (se muestra si hubo búsqueda) -->
    <div class="card mb-4" *ngIf="tieneBusquedaRelacion || tieneBusquedaOtros">
      <div
        class="card-header d-flex justify-content-between align-items-center"
      >
        <span>Totalizadores</span>
        <button
          type="button"
          class="btn btn-link p-0"
          (click)="toggleTotalizadores()"
        >
          <i
            class="bi"
            [ngClass]="{
              'bi-chevron-up': totalizadoresVisible,
              'bi-chevron-down': !totalizadoresVisible
            }"
          ></i>
        </button>
      </div>
      <div class="card-body" *ngIf="totalizadoresVisible">
        <ng-container
          *ngIf="
            pestaniaSeleccionada === 'relacionDependencia';
            else otrosTotales
          "
        >
          <div class="row mb-3">
            <div class="col-md-6">
              <h5 class="mb-0">
                Total:
                <span class="fw-bold">{{ totalPersonasRelacion }}</span>
                personas
              </h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mt-2">
              <h6>Personas por Plan:</h6>
              <ul class="list-group">
                <li
                  *ngFor="let item of desglosePlanRelacion | keyvalue"
                  class="list-group-item d-flex justify-content-between align-items-center"
                >
                  {{ item.key }}
                  <span class="badge bg-primary rounded-pill">{{
                    item.value
                  }}</span>
                </li>
              </ul>
            </div>
            <div class="col-md-6 mt-2">
              <h6>Personas por Obra Social:</h6>
              <ul class="list-group">
                <li
                  *ngFor="let item of desgloseObraSocialRelacion | keyvalue"
                  class="list-group-item d-flex justify-content-between align-items-center"
                >
                  {{ item.key }}
                  <span class="badge bg-success rounded-pill">{{
                    item.value
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
        </ng-container>
        <ng-template #otrosTotales>
          <div class="row mb-3">
            <div class="col-md-6">
              <h5 class="mb-0">
                Tota:
                <span class="fw-bold">{{ totalPersonasOtros }}</span> personas
              </h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mt-2">
              <h6>Personas por Plan:</h6>
              <ul class="list-group">
                <li
                  *ngFor="let item of desglosePlanOtros | keyvalue"
                  class="list-group-item d-flex justify-content-between align-items-center"
                >
                  {{ item.key }}
                  <span class="badge bg-primary rounded-pill">{{
                    item.value
                  }}</span>
                </li>
              </ul>
            </div>
            <div class="col-md-6 mt-2">
              <h6>Personas por Obra Social:</h6>
              <ul class="list-group">
                <li
                  *ngFor="let item of desgloseObraSocialOtros | keyvalue"
                  class="list-group-item d-flex justify-content-between align-items-center"
                >
                  {{ item.key }}
                  <span class="badge bg-success rounded-pill">{{
                    item.value
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Tablas ocultas -->
    <div
      class="table-responsive"
      [ngClass]="{
        'd-none':
          pestaniaSeleccionada !== 'relacionDependencia' ||
          !tablaRelacionVisible
      }"
    >
      <table
        id="tablaRelacionDependencia"
        class="table table-bordered table-hover table-striped"
      >
        <thead class="thead-light">
          <tr></tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>

    <div
      class="table-responsive"
      [ngClass]="{
        'd-none': pestaniaSeleccionada !== 'otros' || !tablaOtrosVisible
      }"
    >
      <table id="tablaOtros" class="table table-bordered table-hover">
        <thead class="thead-light">
          <tr></tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
  </div>
</div>
